<template>
    <div>

        <b-modal v-model="modalVisible" title="Explainer Video" size="lg" hide-footer>
            <iframe width="100%" height="400px" :src="loomVideoUrl" frameborder="0" allowfullscreen></iframe>
        </b-modal>
<!--        <b-progress :value="progress" :max="100"></b-progress>-->

        <div v-if="loading" class="text-center"><img src="/loading.svg" /><p>Loading...</p></div>
        <div v-else>
            <div v-if="displayStart" style="width: 100%; max-width: 500px; margin: 0 auto;">

                <validation-observer ref="observer" v-slot="{ passes }">
                    <form @submit.stop.prevent="passes(generate)">

                        <div class="d-flex justify-content-between align-items-center">
                            <label class="mt-3 d-block font-weight-bold">1. Choose your method</label>
                            <div>
                                <b-button variant="outline" @click="modalVisible = true">
                                    <b-icon icon="play-btn" class="mr-2 text-primary"></b-icon> Explainer
                                </b-button>
                            </div>
                        </div>
                        <div class="card-deck">
                            <div class="card hover-card" @click="executeType = 'demo'" :class="{ 'border-primary': executeType === 'demo' }">
                                <div class="card-body d-flex flex-column align-items-center">
                                    <img src="/icons/demo.svg" style="height: 40px;" class="mx-auto">
                                    <span class="mt-3 d-block font-weight-bold" style="color: #000;">Demo Mode</span>
                                    <span class="mt-3 d-block small">Explore a sample changelog to see what's possible.</span>
                                </div>
                            </div>
                            <div class="card hover-card" @click="executeType = 'copypaste'" :class="{ 'border-primary': executeType === 'copypaste' }">
                                <div class="card-body d-flex flex-column align-items-center">
                                    <img src="/icons/data.svg" style="height: 40px;" class="mx-auto">
                                    <span class="mt-3 d-block font-weight-bold" style="color: #000;">Use Your Data</span>
                                    <span class="mt-3 d-block small">Insert your commits to instantly create your own changelog.</span>
                                </div>
                            </div>
                        </div>




                        <template v-if="executeType === 'copypaste'">
                            <label class="mt-5 d-block">Copy-paste your commits</label>
                            <p class="m-0">Easiest is to select the commits from Sourcetree.</p>
                            <validation-provider name="commits" rules="min:2|max:3000|required" v-slot="{ errors }">
                                <b-form-textarea v-model="commits"></b-form-textarea>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>
                        </template>

                        <label class="mt-5 d-block font-weight-bold">2. Choose your Framework</label>
                        <div class="d-flex">
                            <b-button variant="outline" block class="mt-0 mr-2" @click="framework='tailwind'" :class="{ 'border-primary': framework === 'tailwind' }">Tailwind</b-button>
                            <b-button variant="outline" block class="mt-0 mr-2" @click="framework='bootstrap5'" :class="{ 'border-primary': framework === 'bootstrap5' }">Bootstrap 5</b-button>
                            <b-button variant="outline" block class="mt-0" @click="framework='bootstrap4'" :class="{ 'border-primary': framework === 'bootstrap4' }">Bootstrap 4</b-button>
                        </div>


                        <button :disabled="!(executeType && framework)" type="submit" class="btn btn-primary bg-primary  btn-lg mt-5">Generate changelog <i class="fa fa-arrow-right"></i></button>
                    </form>
                </validation-observer>
            </div>
            <div v-if="displayLoading" class="text-center" style="width: 100%; max-width: 500px; margin: 0 auto;">
                <template v-if="!isGenerated">
                    <p class="text-center"><img src="/loading.svg" style="margin: 0 auto;" /><br>Generating...</p>
                </template>
                <template v-else>
                    <button @click="gotoFinish" class="btn btn-primary btn-lg bg-primary mt-5">See results <i class="fa fa-arrow-right"></i></button>

<!--                    <img src="/img/celebration.gif" style="border-radius: 2rem; margin-bottom: 1.5em;" />-->
                </template>


                <validation-observer ref="observer" v-slot="{ passes }">
                    <form @submit.stop.prevent="passes(signup)">
                        <p class="mt-5 d-block">I want to get updates on new tools and product management tips...</p>
                        <validation-provider name="email" rules="email|required" v-slot="{ errors }">
                            <b-input-group size="" class="mt-2">
                                <b-form-input type="email" class="form-control" autocomplete="email" v-model="email" placeholder="william@shakespeare.com"></b-form-input>
                                <b-input-group-append>
                                    <b-button type="submit" variant="info" class="bg-info" @click="signupSubmitted = true">Yes please</b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <span class="validation d-block mt-2" v-if="signupSubmitted">{{ errors[0] }}</span>
                        </validation-provider>
                        <p class="text-center text-success" v-if="signupComplete">Succesfully signed up</p>

                    </form>
                </validation-observer>

            </div>
            <div v-if="displayFinish">
                <div class="text-center mb-5">
<!--                    <h1 class="my-4 h1">Your changelog is ready 🎉</h1>-->

                    <div class="text-left" style="width: 100%;">
                        <div class="card-deck">
                            <b-card no-body>
                                <b-card-body>
                                    <p class="mb-3">Blast off! Your changelog is ready! 🚀 <br>Check out the results below.</p>
                                </b-card-body>
                                <b-card-footer class="bg-transparent">
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <b-button @click="copyResult" variant="outline">
                                                <b-icon icon="clipboard" class="mr-1"></b-icon>
                                                Copy HTML
                                            </b-button>
                                            <b-button variant="outline" class="ml-2" @click="downloadCsv">
                                                <b-icon icon="download" class="mr-1"></b-icon>
                                                Download CSV
                                            </b-button>
                                        </div>
                                        <b-button @click="restart" variant="link" class="mr-1">
                                            <b-icon icon="arrow-repeat" class="mr-1"></b-icon>
                                            Restart
                                        </b-button>
                                    </div>

                                </b-card-footer>
                            </b-card>

                            <b-card style="background-color: #fff7ed; background-image: linear-gradient(#fff7ed,#fff);" no-body>
                                <b-card-body>
                                    <h1 class="h1">Make changelogs on auto-pilot <b-icon icon="stars"></b-icon> </h1>
                                    <p class="my-3">Effortlessly gather user feedback and generate changelogs to keep everyone updated.</p>
                                </b-card-body>
                                <b-card-footer>
                                    <a href="https://app.productlift.dev/signup" target="_blank" class="btn btn-primary bg-primary mr-2" title="Tip: Download your CSV on the left. You can upload the CSV results from your changelog directly in ProductLift on Posts - File Import." v-b-tooltip>Get started - free <i class="fa fa-arrow-right"></i></a>
                                    <a target="_blank" href="https://www.productlift.dev/changelog" class="btn btn-outline">Explore</a>
                                </b-card-footer>
                            </b-card>
                        </div>
                    </div>


                </div>
                <div v-html="result"></div>


            </div>
        </div>
    </div>
</template>

<script>
import NotificationPop from '../mixins/NotificationPop.js'

export default {
    name: "ChangelogTool",
    mixins: [NotificationPop],
    components: {
    },

    data() {
        return {
            loading: true,
            executeType: null,
            displayStart: true,
            progress: 20,
            language_options: [],
            displayLoading: false,
            displayFinish: false,
            isGenerated: false,
            commits: '',
            email: null,
            framework: null,
            signupSubmitted: false,
            signupComplete: false,
            csvData: '',
            modalVisible: false,
            loomVideoUrl: 'https://www.loom.com/embed/ad9261b26db14f4f86ce7fd75578e5e0',
        }
    },

    async created() {
        this.loading = false;
        //
        // this.$http.get('/api/available_languages')
        //     .then(({data}) => {
        //         this.loading = false;
        //         this.language_options = data
        //     })
        //     .catch(error => {
        //         this.loading = false;
        //         this.popNotification('Something went wrong on our side. Could not load buttons. Please try again or contact support@productlift.dev', 'danger')
        //     });
    },
    methods: {

        restart: function () {
            this.displayStart = true
            this.displayFinish = false
            this.isGenerated = false
            this.commits = ''
            this.email = ''
        },

        generate: function () {
            this.displayStart = false
            this.displayLoading = true

            this.$http.post('/api/changelog_tool',{
                commits: this.commits,
                framework: this.framework,
            })
                .then(({data}) => {
                    this.isGenerated = true
                    this.result = data.result
                    this.csvData = data.csv
                    console.log(data.result)
                })
                .catch(error => {
                    // handle authentication and validation errors here
                    console.log(error.response)
                    this.popNotification('Could not generate the changelog', 'danger')
                })
        },

        /**
         * Show finish
         */
        gotoFinish: function () {
            this.displayLoading = false
            this.displayFinish = true

            this.$confetti.start({
                particles: [
                    {
                        type: 'heart',
                        size: 14,
                    }
                ],
            });
            setTimeout(() => this.$confetti.stop(), 2000);
        },

        /**
         * Create the new portal
         */
        signup: function () {
            // First, make sure signupSubmitted is set to true so that any validation errors will be displayed
            this.signupSubmitted = true;

            // Now, perform the HTTP request
            this.$http.post('/api/tools/signup', {
                email: this.email,
            })
                .then(({ data }) => {
                    this.signupComplete = true
                    // Handle successful signup here
                    console.log("Successfully signed up!", data);
                    this.popNotification('Successfully signed up!', 'success');
                })
                .catch(error => {
                    // Handle authentication and validation errors here
                    console.log(error.response);
                    this.popNotification('Could not complete the signup', 'danger');
                });
        },


        downloadCsv() {
            // Step 1: Create a Blob from the string
            const blob = new Blob([this.csvData], { type: 'text/plain' });

            // Step 2: Create a link to the file
            const fileUrl = URL.createObjectURL(blob);

            // Step 3: Create a temporary anchor tag to trigger download
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.download = 'changelog.csv'; // Set the download file filename here
            document.body.appendChild(anchor); // Required for Firefox

            // Step 4: Trigger the download
            anchor.click();

            // Step 5: Clean up by revoking the URL and removing the anchor
            URL.revokeObjectURL(anchor.href);
            document.body.removeChild(anchor);
        },

        /**
         * Copy key
         */
        copyResult: function () {
            let main = this
            this.$copyText(this.result).then(function (e) {
                main.popNotification('Copied', 'success')
            }, function (e) {
                main.popNotification('Can not copy', 'danger')
            })
        },


    }
}
</script>